function flashInfos(){
    if($('.flash-info .flash-info-wrap').length === 0){
        // cache si vide
        $('.flash-info').hide();
    } else {
        // gestion de starttime et endtime
        $('.flash-info .flash-info-wrap').each(function(){
            var obj = $(this),
                startdate = $(this).attr('data-starttime'),
                enddate = $(this).attr('data-endtime'),
                showObj = false;
            if(startdate > 0 || enddate > 0){
                if(startdate > 0 && enddate === '0'){
                    if(startdate <= dateNow){
                        showObj = true;
                    }
                }
                if(startdate === '0' && enddate > 0){
                    if(enddate >= dateNow){
                        showObj = true;
                    }
                }
            }
            if((startdate > 0 && enddate > 0 && startdate <= dateNow && enddate >= dateNow) || (startdate === '0' && enddate === '0')){
                showObj = true;
            }
            if(showObj === true)
                obj.show();
        });
        if($('.flash-info .flash-info-wrap:visible').length === 0)
            $('.flash-info').hide();
    }
    // cache via localStorage
    $('.flash-info .flash-info-close').on('click',function(){
        $('.flash-info').hide();
        localStorage.setItem('hideFlashInfos', $(this).parents('.flash-info').attr('data-tstamp'));
    });
    if (typeof localStorage.getItem('hideFlashInfos') !== "undefined" && localStorage.getItem('hideFlashInfos') !== null) {
        if(localStorage.getItem('hideFlashInfos') === $('.flash-info').attr('data-tstamp'))
            $('.flash-info').hide();
        else
            localStorage.removeItem('hideFlashInfos');
    }
}
